import React, { useState, useEffect, useRef } from 'react';
import EmojiPicker from 'emoji-picker-react';
import './emojiPicker.scss';
import { Tooltip, OverlayTrigger } from 'ui';

const EmojiPickerPopup = ({ onSelect = () => {} }) => {
  const [open, setOpen] = useState(false);
  const emojiContainer = useRef(null);

  useEffect(() => {
    const mouseDownHandler = (event) => {
      // If the selector isn't open or we don't have a handle on it's container return early
      if (!open || emojiContainer.current === null) {
        return;
      }
      // If the click was inside the container return early
      if (emojiContainer.current.contains(event.target)) {
        return;
      }
      // Otherwise close the selector
      setOpen(false);
    };
    window.addEventListener('mousedown', mouseDownHandler);
    return () => {
      window.removeEventListener('mousedown', mouseDownHandler);
    };
  }, [open]);

  const closeSelector = () => {
    // set timeout here to pop the closing of the selector off the queue to allow time for any click events to fire
    setTimeout(() => {
      setOpen(false);
    }, 50);
  };

  const openSelector = () => {
    if (open) {
      return closeSelector();
    }
    setOpen(true);
  };

  const select = ({ emoji }) => {
    closeSelector();
    onSelect(emoji);
  };

  const renderSelector = () => {
    if (!open) {
      return null;
    }
    return (
      <div className="emoji-picker-popup">
        <EmojiPicker
          onEmojiClick={select}
          lazyLoadEmojis={true}
          searchPlaceHolder="Search Emojis"
        />
      </div>
    );
  };

  return (
    <div
      ref={emojiContainer}
      className={`emoji-menu-item ${open ? 'open' : null}`}
    >
      {renderSelector()}
      <span onClick={openSelector}>
        <OverlayTrigger
          placement="top"
          delay={{ show: 0, hide: 0 }}
          overlay={<Tooltip id={'emoji-icon'}>Use an emoji</Tooltip>}
        >
          <i className="far fa-smile" id="emoji-icon"></i>
        </OverlayTrigger>
      </span>
    </div>
  );
};

export default EmojiPickerPopup;
